import React from 'react';
import Modal from '@/components/Modal';
import Button from '@/components/Button';
import { PasskeyIcon, PlusOutlineIcon } from '@/components/Icons';
import { passkeySetupPromptModal } from '@/utils/translations';

interface PasskeySetupPromptModalProps {
  isOpen: boolean;
  isCreating: boolean;
  onNotNow: () => void;
  onCreatePasskey: () => void;
}

const Header = () => (
  <div className="flex flex-col gap-y-2">
    <PasskeyIcon size="2xl" className="w-[52px] h-[52px]" />
    <span className="text-emerge-navy text-2xl font-medium">{passkeySetupPromptModal.title}</span>
  </div>
);

// First-time prompt shown after a QR-code login when the customer has no passkey registered
// yet - offers to set one up on this device instead. No close (X) button by design (matches
// Figma); dismissal only happens via the explicit "Not now" action.
const PasskeySetupPromptModal: React.FC<PasskeySetupPromptModalProps> = ({
  isOpen,
  isCreating,
  onNotNow,
  onCreatePasskey
}) => (
  <Modal isOpen={isOpen} variant="md" headerText={<Header />}>
    <div className="pt-5 flex flex-col gap-y-6">
      <p className="text-dark-navy-30 text-sm font-normal leading-5">
        {passkeySetupPromptModal.description}
      </p>
      <div className="flex items-center justify-center gap-x-5">
        <Button
          size="pill"
          className="py-2"
          childrenClassName="text-xs"
          onClick={onCreatePasskey}
          disabled={isCreating}>
          <PlusOutlineIcon size="sm" />
          {passkeySetupPromptModal.createButton}
        </Button>
        <Button
          variant="secondary"
          size="pill"
          className="w-[140px] py-2"
          childrenClassName="text-xs"
          onClick={onNotNow}
          disabled={isCreating}>
          {passkeySetupPromptModal.notNowButton}
        </Button>
      </div>
    </div>
  </Modal>
);

export default PasskeySetupPromptModal;
